export * from './shift.reducer';



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/store/reducers/index.ts